export default class DtoSTEPCivilEng {
    constructor(obj) {
        this.idStation = obj.idStation

        this.bufferTank = obj.bufferTank
        this.bufferTankVolume = obj.bufferTankVolume
        this.buildings = obj.buildings
        this.description = obj.description
    }
}